






module.exports =
	components:
		siteHeader: require "components/common/siteHeader"
		siteFooter: require "components/common/siteFooter"



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/app.vue